import {
  getAction
} from '@/api/manage'

const state = {
  categoryList: null
}

const getters = {
  categoryList: state => {
    if (!state.categoryList) return []
    let rst = state.categoryList.map(t => {
      return {
        id: t.id,
        name: t.name,
        pid: t.parentId
      }
    })
    return rst
  }
}

const mutations = {
  setCategoryList(state, list) {
    state.categoryList = list
  }
}

const actions = {
  getCategoryList({
    commit
  }) {
    return new Promise((resolve, reject) => {
      if (state.categoryList) {
        resolve(state.categoryList)
      } else {
        getAction('category/list').then(rst => {
          if (rst.success) {
            let result = rst.result
            commit('setCategoryList', result)
            resolve(result)
          } else {
            reject([])
          }
        }).catch(error => {
          reject(error)
        })
      }
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}